import * as React from 'react'
import { forwardRef } from 'react'
import { useLogout } from 'react-admin'
import ExitIcon from '@mui/icons-material/PowerSettingsNew'
import MenuItem from '@mui/material/MenuItem'

const LogoutButton = forwardRef((_props: any, ref: any) => {
  const logout = useLogout()

  const handleClick = async () => {
    try {
      await logout()
    } catch (e) {
      console.log('error', e)
    }
  }

  return (
    <MenuItem onClick={handleClick} ref={ref}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ExitIcon /> <span style={{ marginLeft: 10 }}>Log Out</span>
      </div>
    </MenuItem>
  )
})

export default LogoutButton
